export function getProperty(object: Record<string, any>, propertyList: string[]): any {
    let result = object;

    // propertyList data can be represented as a single property "b" or as a point in
    // an array property "b[0]".  If a point in an array property is provided,
    // we'll need to remove the index number and characters from the property name
    // and then use their numerical representation as a proper array index.
    for (let i = 0; i < propertyList.length; i++) {
        if (!result) {
            return undefined;
        }
        // check for numbers surrounded by square brackets to determine if we're
        // dealing with an array property
        const indexData = propertyList[i].match(/\[([0-9]+)\]/);
        if (indexData) {
            // get the "name" of the property (without index notation)
            const arrayProperty = propertyList[i].slice(0, indexData.index);

            // use the "name" as the lookup key and the extracted numerical data as the index
            result = result[arrayProperty][indexData[1]];
            // return result;
        }
        // make sure we're dealing with a valid property
        else if (result === null || result === undefined) {
            return undefined;
        }
        // go down to the child property
        else if (propertyList[i] in result) {
            result = result[propertyList[i]];
        }
        else {
            return undefined;
        }
    }
    return result;
};

export function propertyExists(object: Record<string, any>, propertyList: string[]) {
    return getProperty(object, propertyList) !== undefined;
};

export function setProperty(object: Record<string, any>, propertyList: string[], value: any) {
    const npropertyList = propertyList.slice();
    const s = npropertyList.pop();
    if (!s) {
        throw new Error('Can\'t set property with an empty propertyList');
    }
    const inbetween = getProperty(object, npropertyList);

    // propertyList data can be represented as a single property "b" or as a point in
    // an array property "b[0]".  If a point in an array property is provided,
    // we'll need to remove the index number and characters from the property name
    // and then use their numerical representation as a proper array index.

    // check for numbers in property name to determine if we're dealing with an array property
    const indexData = s.match(/\[([0-9]+)\]/);
    if (indexData) {
        // get the "name" of the property (without index notation)
        npropertyList.push(s.slice(0, indexData.index));

        // get a reference to the array
        const propertyArray = getProperty(object, npropertyList);

        // set value at index and exit
        if (propertyArray[indexData[1]] !== value) {
            propertyArray[indexData[1]] = value;
        }
    }
    else {
        const propertyType = typeof inbetween[s];
        if (propertyType === 'number' && inbetween[s] !== value) {
            inbetween[s] = value;
        }
        else if (propertyType === 'boolean' && inbetween[s] !== Boolean(value)) {
            inbetween[s] = Boolean(value);
        }
    }
};
